"use strict";
var wall = document.querySelector(".wall");
var spider = document.querySelector(".spider");
spider.style.position = "absolute";
wall.style.position = "relative";
var spiderWidth = spider.clientWidth;
var spiderHeight = spider.clientHeight;
var wallWidth = wall.clientWidth;
var wallHeight = wall.clientHeight;
var leftPos = (wallWidth - spiderWidth) / 2;
var topPos = (wallHeight - spiderHeight) / 2;
spider.style.left = "".concat(leftPos, "px");
spider.style.top = "".concat(topPos, "px");

//# sourceMappingURL=index.f6593d90.js.map
